export const API_KEY = "45df0f7652cb67f2ec7fa3f0ba9007a8";


export const sunIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className="w-24 h-24 p-2 text-yellow-500 fill-current"
    >
      <path d="M256,104c-83.813,0-152,68.187-152,152s68.187,152,152,152,152-68.187,152-152S339.813,104,256,104Zm0,272A120,120,0,1,1,376,256,120.136,120.136,0,0,1,256,376Z"></path>
      <rect width="32" height="48" x="240" y="16"></rect>
      <rect width="32" height="48" x="240" y="448"></rect>
      <rect width="48" height="32" x="448" y="240"></rect>
      <rect width="48" height="32" x="16" y="240"></rect>
      <rect
        width="32"
        height="45.255"
        x="400"
        y="393.373"
        transform="rotate(-45 416 416)"
      ></rect>
      <rect
        width="32.001"
        height="45.255"
        x="80"
        y="73.373"
        transform="rotate(-45 96 96)"
      ></rect>
      <rect
        width="45.255"
        height="32"
        x="73.373"
        y="400"
        transform="rotate(-45.001 96.002 416.003)"
      ></rect>
      <rect
        width="45.255"
        height="32.001"
        x="393.373"
        y="80"
        transform="rotate(-45 416 96)"
      ></rect>
    </svg>
  );


  export const iceFlakes = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className="w-24 h-24 p-2 text-white fill-current"
    >
      <polygon points="135.279 206.728 224.136 258.323 144.097 304.797 48.308 279.129 48.308 312.259 123.155 332.313 102.99 407.571 131.68 424.135 155.518 335.169 240 286.115 240 374.402 168.823 445.579 197.513 462.144 258 401.657 317.135 460.792 345.826 444.228 272 370.402 272 286.115 355.002 334.31 379.279 424.914 407.97 408.349 387.596 332.313 464 311.841 464 278.712 367.508 304.567 287.864 258.323 376.327 206.957 464 230.449 464 197.32 394.346 178.657 413.576 106.888 384.886 90.323 361.196 178.739 272 230.53 272 130.568 338.833 63.735 310.143 47.171 254.971 102.343 200.664 48.037 171.974 64.601 240 132.627 240 230.53 149.325 177.88 126.073 91.103 97.382 107.667 116.404 178.657 48.308 196.903 48.308 230.032 135.279 206.728"></polygon>
    </svg>
  );


  export const cloudIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className="w-24 h-24 p-2 fill-current"
    >
      <path d="M382.76,432H136c-30.732,0-61.371-12.725-84.061-34.912-23.221-22.707-36.009-52.35-36.009-83.469A109.4,109.4,0,0,1,49.136,235.2a122.281,122.281,0,0,1,62.794-32.707V200c0-79.4,64.6-144,144-144s144,64.6,144,144v1.453c55.716,7.939,96,53.729,96,112.166,0,31.27-11.375,60.72-32.031,82.927A109.747,109.747,0,0,1,382.76,432ZM255.93,88a112.127,112.127,0,0,0-112,112v31.405l-14.864,1.059c-45.5,3.239-81.136,38.887-81.136,81.155C47.93,359.635,89.084,400,136,400H382.76c45.515,0,81.17-37.943,81.17-86.381,0-46.566-33.731-80.791-80.2-81.379l-15.8-.2V200A112.127,112.127,0,0,0,255.93,88Z"></path>
    </svg>
  );